module.exports = __webpack_public_path__ + "5c2dbb07b28ee5a0802f00bd2ef71379.svg";